<template>
  <div class="card order-table">
    <header class="card-header">
      <div class="card-header-title has-text-dark is-size-4">
        <p>ORDERS CALENDAR</p>
      </div>

      <div class="buttons">
        <slot name="headerButtons" />
      </div>
    </header>

    <div class="card-content is-size-6" ref="cardContent">
      <order-calendar
        :filters="filters"
        :order="order"
        :show-date="showDate"
        @click-item="(order) => $emit('click-item', order)"
        @generate-items="(payload) => $emit('generate-items', payload)"
        ref="calendar"
      />
    </div>
  </div>
</template>

<script>
import OrderCalendar from "@/components/Order/OrderCalendar";

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    order: {
      type: Object,
    },
    showDate: {
      type: String,
    },
  },
  components: {
    OrderCalendar,
  },
};
</script>

<style lang="scss" scoped>
.card-content {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/partials/calendar.vue